export const getPrice = (value: number) => {
  const integer = Math.floor(value);
  const price = integer.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return price;
};
